export const FlexDiv = props => {
  const { onClick, style, children } = props;
  return (
    <div style={{ display: "flex", ...style }} onClick={onClick}>
      {children}
    </div>
  );
};
